var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgViThroughLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_1988",
    "data-name": "Gruppe 1988",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 252.015,
    height: 67.887,
    viewBox: "0 0 252.015 67.887",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_470",
    "data-name": "Rechteck 470",
    width: 252.015,
    height: 67.887,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1951",
    "data-name": "Pfad 1951",
    d: "M53.419,40.711l-12.163,28.1H34.834l-12.123-28.1h7.025l8.55,20.07,8.67-20.07Z",
    transform: "translate(-11.382 -20.402)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1987",
    "data-name": "Gruppe 1987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1986",
    "data-name": "Gruppe 1986",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1952",
    "data-name": "Pfad 1952",
    d: "M91.35,37.2a3.579,3.579,0,0,1,3.894-3.492c2.328,0,3.894,1.445,3.894,3.372a3.91,3.91,0,0,1-7.787.121m.763,6.5h6.262V65.3H92.113Z",
    transform: "translate(-45.78 -16.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1953",
    "data-name": "Pfad 1953",
    d: "M159.265,69.5a8.948,8.948,0,0,1-5.1,1.365c-5.1,0-8.068-2.609-8.068-7.747V54.246h-3.331V49.429H146.1V44.171h6.262v5.258h5.379v4.817H152.36v8.791a2.518,2.518,0,0,0,2.689,2.85,4.219,4.219,0,0,0,2.529-.8Z",
    transform: "translate(-71.547 -22.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1954",
    "data-name": "Pfad 1954",
    d: "M209.019,54.752V67.115h-6.262v-11.4c0-3.492-1.605-5.1-4.375-5.1-3.011,0-5.178,1.847-5.178,5.821V67.115h-6.262V37.331H193.2V47.768a9.492,9.492,0,0,1,6.864-2.569c5.1,0,8.951,2.97,8.951,9.553",
    transform: "translate(-93.685 -18.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1955",
    "data-name": "Pfad 1955",
    d: "M259.975,53.1v5.78c-.522-.04-.923-.08-1.4-.08-3.452,0-5.74,1.887-5.74,6.021v10.2h-6.262v-21.6h5.981v2.849c1.525-2.087,4.095-3.171,7.426-3.171",
    transform: "translate(-123.566 -26.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1956",
    "data-name": "Pfad 1956",
    d: "M281.33,64.221c0-6.5,5.017-11.119,11.881-11.119s11.842,4.616,11.842,11.119S300.076,75.34,293.211,75.34,281.33,70.724,281.33,64.221m17.381,0c0-3.733-2.368-5.981-5.5-5.981s-5.539,2.248-5.539,5.981,2.409,5.981,5.539,5.981,5.5-2.248,5.5-5.981",
    transform: "translate(-140.987 -26.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1957",
    "data-name": "Pfad 1957",
    d: "M362.912,53.746v21.6h-5.941V72.772a8.737,8.737,0,0,1-6.7,2.89c-5.419,0-9.232-3.051-9.232-9.714v-12.2H347.3v11.28c0,3.613,1.606,5.218,4.375,5.218,2.89,0,4.978-1.846,4.978-5.82V53.746Z",
    transform: "translate(-170.908 -26.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1958",
    "data-name": "Pfad 1958",
    d: "M421.246,53.423V71.406c0,8.028-4.336,11.721-12.123,11.721-4.094,0-8.068-1-10.6-2.97l2.489-4.5a12.909,12.909,0,0,0,7.627,2.448c4.415,0,6.342-2.007,6.342-5.9v-.923a8.889,8.889,0,0,1-6.824,2.689c-5.981,0-10.8-4.135-10.8-10.437S402.178,53.1,408.16,53.1a8.669,8.669,0,0,1,7.145,3.091v-2.77Zm-6.182,10.115c0-3.171-2.369-5.3-5.661-5.3s-5.7,2.128-5.7,5.3,2.408,5.3,5.7,5.3,5.661-2.127,5.661-5.3",
    transform: "translate(-199.136 -26.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1959",
    "data-name": "Pfad 1959",
    d: "M483.007,54.752V67.115h-6.262v-11.4c0-3.492-1.605-5.1-4.375-5.1-3.011,0-5.178,1.847-5.178,5.821V67.115H460.93V37.331h6.262V47.768a9.492,9.492,0,0,1,6.864-2.569c5.1,0,8.951,2.97,8.951,9.553",
    transform: "translate(-230.992 -18.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1960",
    "data-name": "Pfad 1960",
    d: "M103.822,118.9h6.9a7.456,7.456,0,0,0,7.456-7.456v-6.9h-1.634v5.64a7.082,7.082,0,0,1-7.082,7.081h-5.639",
    transform: "translate(-52.03 -52.391)",
    fill: "#ae44ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1961",
    "data-name": "Pfad 1961",
    d: "M111.575,104.543v4.992a2.762,2.762,0,0,1-2.762,2.762h-4.992v4.967h5.64a7.081,7.081,0,0,0,7.081-7.082v-5.639",
    transform: "translate(-52.029 -52.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1962",
    "data-name": "Pfad 1962",
    d: "M103.822,120.277h7.963a7.772,7.772,0,0,0,7.772-7.772v-7.964h-1.38v6.9a7.456,7.456,0,0,1-7.456,7.456h-6.9",
    transform: "translate(-52.03 -52.391)",
    fill: "#6b9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1963",
    "data-name": "Pfad 1963",
    d: "M118.177,17.121v-6.9a7.456,7.456,0,0,0-7.456-7.456h-6.9V4.4h5.64a7.081,7.081,0,0,1,7.081,7.082v5.639",
    transform: "translate(-52.029 -1.386)",
    fill: "#ae44ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1964",
    "data-name": "Pfad 1964",
    d: "M103.822,11.01h4.992a2.762,2.762,0,0,1,2.762,2.762v4.992h4.967v-5.64a7.081,7.081,0,0,0-7.082-7.081h-5.639",
    transform: "translate(-52.03 -3.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1965",
    "data-name": "Pfad 1965",
    d: "M119.556,15.734V7.771A7.772,7.772,0,0,0,111.785,0h-7.964v1.38h6.9a7.456,7.456,0,0,1,7.456,7.456v6.9",
    transform: "translate(-52.029 0.001)",
    fill: "#6b9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1966",
    "data-name": "Pfad 1966",
    d: "M17.122,2.766h-6.9a7.456,7.456,0,0,0-7.456,7.456v6.9H4.4v-5.64A7.081,7.081,0,0,1,11.483,4.4h5.639",
    transform: "translate(-1.386 -1.386)",
    fill: "#ae44ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1967",
    "data-name": "Pfad 1967",
    d: "M11.01,18.763V13.771a2.762,2.762,0,0,1,2.762-2.762h4.992V6.042h-5.64a7.081,7.081,0,0,0-7.081,7.082v5.639",
    transform: "translate(-3.028 -3.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1968",
    "data-name": "Pfad 1968",
    d: "M15.735,0H7.772A7.772,7.772,0,0,0,0,7.772v7.964H1.38v-6.9A7.456,7.456,0,0,1,8.836,1.38h6.9",
    fill: "#6b9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1969",
    "data-name": "Pfad 1969",
    d: "M2.766,104.542v6.9a7.456,7.456,0,0,0,7.456,7.456h6.9v-1.635h-5.64A7.081,7.081,0,0,1,4.4,110.181v-5.639",
    transform: "translate(-1.386 -52.391)",
    fill: "#ae44ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1970",
    "data-name": "Pfad 1970",
    d: "M18.763,112.3H13.771a2.762,2.762,0,0,1-2.762-2.762v-4.992H6.042v5.64a7.082,7.082,0,0,0,7.082,7.081h5.639",
    transform: "translate(-3.028 -52.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1971",
    "data-name": "Pfad 1971",
    d: "M0,104.542v7.963a7.772,7.772,0,0,0,7.772,7.772h7.964V118.9h-6.9a7.456,7.456,0,0,1-7.456-7.456v-6.9",
    transform: "translate(0 -52.391)",
    fill: "#6b9797"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViThroughLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Vi_through_Logo.ed6f40242724d03dff28c0f8add61848.svg";